<div class="sc__loader"></div>